<ng-container *ngIf="similarProducts$ | async as similarProducts">
  <h2 class="carousel-title" *ngIf="similarProducts.length > 0 && displayTitle">
    {{ title ? title : ("product.carousel.related_products" | translate) }}
  </h2>
  <ep-product-carousel
    class="product-carousel"
    [products]="similarProducts"
    [hasAddToListButton]="hasAddToListButton"
    [isLoading]="isSimilarProductsLoading$ | async"
  ></ep-product-carousel>
</ng-container>
